module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Delete Post","description":"Do you want to delete the post:","alert":"Post was deleted successfully!","btnDelete":"Yes, delete it now"},"es":{"title":"Eliminar Publicación","description":"Quieres eliminar la publicación:","alert":"¡Publicación fue eliminada satisfactorimente!","btnDelete":"Sí, eliminar ahora"}}')
  delete Component.options._Ctor
}
